  <template>
        <div id="marketHistoryTabs">
            <ejs-tab id="element" ref="marketHistoryTabs" :selecting='selecting'>
                <e-tabitems>
                    <e-tabitem :header='headerText0' :content="powerHistory"></e-tabitem>
                    <e-tabitem :header='headerText1' :content="gasHistory"></e-tabitem>
                </e-tabitems>
            </ejs-tab>
        </div>
    </template>

<script>
    import Vue from "vue";
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import powerFuturesHistory from '@/views/markets/marketSummaryHistory/PowerHistory.vue';
    import gasFuturesHistory from '@/views/markets/marketSummaryHistory/GasHistory.vue';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';


    Vue.use(TabPlugin);
    export default Vue.extend({
        created() {
            showSpinner(document.getElementById('mainSpinner'));
        },
        name: 'marketHistoryTabs',
        data: function () {
            return {
                headerText0: { text: 'Power Expired' },
                headerText1: { text: 'Gas Expired' },

                powerHistory: function () {
                  
                    return {
                        template: {
                            extends: powerFuturesHistory
                        }

                    }
                },
                gasHistory: function () {
                    return {
                        template: {
                            extends: gasFuturesHistory
                        }

                    }
                }

            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '100',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });

        },
        methods: {
            selecting: function (args) {
                //console.log(args);
                //if (args.isInteracted) {
                //    showSpinner(document.getElementById('mainSpinner'));
                //}
            }
        }

    });


</script>
<style>

    .parentMarketExpired {
        display: flex;
    }

</style>